"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("./Icon"));
var react_popper_1 = require("react-popper");
var Chip = function (_a) {
    var text = _a.text, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, className = _a.className, disabled = _a.disabled, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, onLeadingIconClick = _a.onLeadingIconClick, onTrailingIconClick = _a.onTrailingIconClick, _c = _a.tooltipContent, tooltipContent = _c === void 0 ? null : _c, _d = _a.tooltipPlacement, tooltipPlacement = _d === void 0 ? 'top' : _d;
    var popperRef = (0, react_1.useRef)(null);
    var triggerRef = (0, react_1.useRef)(null);
    var arrowElement = (0, react_1.useRef)(null);
    var _e = __read(react_1.default.useState(false), 2), showTooltip = _e[0], setShowTooltip = _e[1];
    var handleMouseEnter = (0, react_1.useCallback)(function () {
        setShowTooltip(true);
    }, []);
    var handleMouseLeave = (0, react_1.useCallback)(function () {
        setShowTooltip(false);
    }, []);
    var _f = (0, react_popper_1.usePopper)(triggerRef.current, popperRef.current, {
        placement: tooltipPlacement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                },
            },
            {
                name: 'arrow',
                options: {
                    element: arrowElement.current,
                    padding: {
                        top: 10,
                        bottom: 10,
                        left: 5,
                        right: 5,
                    },
                },
            },
        ],
    }), styles = _f.styles, attributes = _f.attributes;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-chip", "ui-chip-" + variant, className), role: "button", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        leadingIcon && !disabled ? (react_1.default.createElement("div", { className: "ui-chip-icon-wrapper", ref: triggerRef },
            react_1.default.createElement(Icon_1.default, { icon: leadingIcon, className: (0, classnames_1.default)('ui-chip-icon', onLeadingIconClick && 'ui-chip-icon-clickable'), onClick: onLeadingIconClick ? function () { return onLeadingIconClick(); } : undefined, size: "xxsmall" }))) : null,
        react_1.default.createElement("span", { className: "ui-chip-text" }, text),
        trailingIcon && !disabled ? (react_1.default.createElement("div", { className: "ui-chip-icon-wrapper", ref: triggerRef },
            react_1.default.createElement(Icon_1.default, { icon: trailingIcon, className: (0, classnames_1.default)('ui-chip-icon', onTrailingIconClick && 'ui-chip-icon-clickable'), onClick: onTrailingIconClick ? function () { return onTrailingIconClick(); } : undefined, size: "xxsmall" }))) : null,
        tooltipContent !== null && (react_1.default.createElement("div", __assign({ className: "ui-tooltip", ref: popperRef, style: __assign({ display: showTooltip ? 'block' : 'none' }, styles.popper) }, attributes.popper),
            tooltipContent,
            react_1.default.createElement("div", { className: "ui-tooltip-arrow", ref: arrowElement, style: styles.arrow })))));
};
exports.default = Chip;
